<div class="main-page-content">

  <div class="main-page-content-block" *ngIf="!currentItem">
    Loading...
  </div>
  <div class="main-page-content-block text-lg" *ngIf="currentItem">
    <div class="row">
      <div class="col ">
        <h1 class="content-heading-font">
          #{{ currentItem.ID }} {{currentItem.ApplicationName }}
        </h1>

      </div>
    </div>
    <div class="row">
      <div class="col mb-2">
        {{ currentItem.Type }}: {{currentItem.Message }}
      </div>
    </div>
    <div class="row">
      <div class="col-12  col-xl-6  ">
        <ul class="list-group mb-2 ">

          <li class="list-group-item d-flex justify-content-between align-items-center">
            <b>Creation Date</b>
            <span class="ms-2">{{formatMountainTime(currentItem.CreationDate) }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="currentItem.LastLogDate">
            <b>Last Log Date</b>
            <span class="ms-2">
              {{formatMountainTime(currentItem.LastLogDate) }}
            </span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="currentItem.DuplicateCount!=1">
            <b>Duplicate Count</b>
            <span class="ms-2">{{ currentItem.DuplicateCount }} </span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="ClientSite">
            <b>Client</b>
            <span class="ms-2">{{ ClientSite }} </span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="currentItem.Source || SourceFile">
            <b>Source</b>
            <span class="ms-2" *ngIf="!getCodeLink()">{{ currentItem.Source  || SourceFile }} </span>
            <a href="{{getCodeLink()}}" target="_blank" *ngIf="getCodeLink()">{{ SourceFile }}</a>
          </li>
        </ul>
      </div>

      <div class="col-12  col-xl-6  " *ngIf="currentItem.Host">
        <ul class="list-group  mb-2">
          <li class="list-group-item d-flex justify-content-between align-items-center text-break">
            <b>HTTP {{ currentItem.HTTPMethod }}</b>
            <a href="https://{{ currentItem.Host }}{{ currentItem.Url }}" class="ms-2" target="_blank" *ngIf="!FullUrl">{{ currentItem.Host }}{{ currentItem.Url }}</a>
            <a href="{{ FullUrl }}" class="ms-2" target="_blank" *ngIf="FullUrl">{{ FullUrl }}</a>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="RequestHeaders?.Referer">
            <b>Referer</b>
            <a href="{{ RequestHeaders?.Referer }}" class="ms-2" target="_blank">{{ RequestHeaders?.Referer }}</a>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="Device">
            <b>Device</b>
            <span class="ms-2">{{ Device }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="currentItem && currentItem.IPAddress">
            <b>IP Address</b>
            <div class="ms-2">
              {{ currentItem.IPAddress}}
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="!isEmptyObj(User)">
            <b>User</b>
            <div class="ms-2">
              {{ User.name  || User.nameidentifier|| User.LastUsername }} [{{ User.sid }}]
            </div>
          </li>
        </ul>
      </div>

      <div class="col-12  col-xl-6  " *ngIf="currentItem.GitHub_IssueNumber || currentItem.SupportTicketID">
        <ul class="list-group  mb-2">
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="currentItem.GitHub_IssueNumber">
            <b>GitHub Issue</b>
            <a href="https://github.com/UTBS/{{ currentItem?.GitHub_Repository }}/issues/{{ currentItem?.GitHub_IssueNumber }}" class="ms-2" target="_blank">{{ currentItem?.GitHub_Repository }} #{{ currentItem?.GitHub_IssueNumber }}</a>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center text-break" *ngIf="currentItem.SupportTicketID">
            <b>Support Ticket </b>
            <div class="d-inline-block">
              <a href="/tickets" [routerLink]="['/tickets/'+currentItem.SupportTicketID]" class="ms-2" target="_blank">
                #{{ currentItem?.SupportTicketID }} - {{ currentItem?.SupportTicket_Subject }}
              </a>
              <span *ngIf="currentItem.SupportTicket_DateClosed" class="text-info" title="{{formatMountainTime(currentItem.SupportTicket_DateClosed)}}">(Closed)</span>
              <span *ngIf="!currentItem.SupportTicket_DateClosed" class="text-primary" title="{{formatMountainTime(currentItem.SupportTicket_DateCreated)}}">(Open)</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-center ">
        <button class="btn btn-lg btn-primary me-2" type="submit" id="btnGithub" [class.button-loading]="loading" (click)="showLinkGitHub()">GitHub Issue</button>
        <button class="btn btn-lg btn-primary me-2" type="submit" id="btnTicket" [class.button-loading]="loading" (click)="showLinkTicket()">Support Ticket</button>
        <button class="btn btn-lg btn-danger me-2" type="submit" id="btnDelete" [class.button-loading]="loading" (click)="delete()">Delete</button>
        <a class="btn btn-secondary me-2" [href]="getMonitorLink()" target="_blank">View on monitor</a>
        <a class="btn btn-info me-2" [routerLink]="['/exceptionlog/' ]">Back to exception list</a>

      </div>
    </div>
  </div>

  <div class="main-page-content-block-secondary mt-3 ">
    <ul class="nav  justify-content-center nav-underline text-lg " id="dataTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link  active" id="Details-tab" data-bs-toggle="tab" data-bs-target="#Details"
                type="button" role="tab" aria-controls="Details" aria-selected="true">
          Error Details
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="currentItem && currentItem.Duplicates  && currentItem.Duplicates.length > 0 ">
        <button class="nav-link" id="DuplicatesData-tab" data-bs-toggle="tab" data-bs-target="#DuplicatesData"
                type="button" role="tab" aria-controls="DuplicatesData" aria-selected="true">
          Duplicates 
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(Form)">
        <button class="nav-link" id="FormData-tab" data-bs-toggle="tab" data-bs-target="#FormData"
                type="button" role="tab" aria-controls="FormData" aria-selected="true">
          Form Data
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(QueryString)">
        <button class="nav-link" id="QueryStringData-tab" data-bs-toggle="tab" data-bs-target="#QueryStringData"
                type="button" role="tab" aria-controls="QueryStringData" aria-selected="false">
          Query String
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(CustomData)">
        <button class="nav-link" id="OtherData-tab" data-bs-toggle="tab" data-bs-target="#OtherData"
                type="button" role="tab" aria-controls="OtherData" aria-selected="false">
          Custom Data
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(User)">
        <button class="nav-link" id="UserData-tab" data-bs-toggle="tab" data-bs-target="#UserData"
                type="button" role="tab" aria-controls="UserData" aria-selected="false">
          User Info
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(Session)">
        <button class="nav-link" id="SessionData-tab" data-bs-toggle="tab" data-bs-target="#SessionData"
                type="button" role="tab" aria-controls="SessionData" aria-selected="false">
          Session Data
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(RequestHeaders)">
        <button class="nav-link" id="RequestHeaders-tab" data-bs-toggle="tab" data-bs-target="#RequestHeaders"
                type="button" role="tab" aria-controls="RequestHeaders" aria-selected="false">
          Request Headers
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(Cookies)">
        <button class="nav-link" id="Cookies-tab" data-bs-toggle="tab" data-bs-target="#Cookies"
                type="button" role="tab" aria-controls="Cookies" aria-selected="false">
          Cookies
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(ServerVariables)">
        <button class="nav-link" id="ServerVariables-tab" data-bs-toggle="tab" data-bs-target="#ServerVariables"
                type="button" role="tab" aria-controls="ServerVariables" aria-selected="false">
          Server Variables
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="!isEmptyObj(FullJson)">
        <button class="nav-link" id="ErrorData-tab" data-bs-toggle="tab" data-bs-target="#ErrorData"
                type="button" role="tab" aria-controls="ErrorData" aria-selected="false">
          Other Error Data
        </button>
      </li>

    </ul>
    <div class="tab-content" id="dataTabContent">
      <div id="FormData" class="tab-pane fade" role="tabpanel" aria-labelledby="FormData-tab" tabindex="0" *ngIf="Form ">
        <pre>{{ Form | prettyJson}}</pre>
      </div>
      <div id="DuplicatesData" class="tab-pane fade" role="tabpanel" aria-labelledby="DuplicatesData-tab" tabindex="0" *ngIf="currentItem?.Duplicates ">
        <table class="w-100 table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Creation Date</th>
              <th>Last Log Date</th>
              <th>User</th>
              <th>IP Address</th>
              <th>Url</th>
              <th>Application</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let duplicate of currentItem?.Duplicates">
              <th>
                <a href="#" [routerLink]="['/exceptionlog/'+  duplicate.ID ]">
                  {{ duplicate.ID }}
                </a>
              </th>
              <td>
                {{formatMountainTime(duplicate.CreationDate)}}
              </td>
              <td>
                {{formatMountainTime(duplicate.LastLogDate)}}
              </td>
              <td>
                {{duplicate.UserName}}
              </td>
              <td>
                {{duplicate.IPAddress}}
              </td>
              <td>
                {{duplicate.Url}}
              </td>
              <td>
                {{duplicate.ApplicationName}}
              </td>
              <td>
                {{duplicate.DuplicateCount}}
              </td>
            </tr>
          </tbody>
        </table>
       

      </div>
      <div id="OtherData" class="tab-pane fade" role="tabpanel" aria-labelledby="OtherData-tab" tabindex="0" *ngIf="CustomData ">
        <pre>{{ CustomData | prettyJson}}</pre>
      </div>
      <div id="UserData" class="tab-pane fade text-lg" role="tabpanel" aria-labelledby="UserData-tab" tabindex="0" *ngIf="User ">


        <img *ngIf="User.picture" class="profileImage float-right" src="{{ User.picture }} " />
        <div class="mb-2" *ngIf="User.sid">
          <b>ID</b>
          {{ User.sid}}
        </div>
        <div class="mb-2" *ngIf="User.name || User.nameidentifier|| User.LastUsername">
          <b>name</b>
          {{ User.name || User.nameidentifier|| User.LastUsername}}
        </div>
        <div class="mb-2" *ngIf="User.groupsid">
          <b>Client</b>
          {{ User.groupsid}}
        </div>
        <div class="mb-2" *ngIf="User.usersessionid">
          <b>User Session id</b>
          {{ User.usersessionid}}
        </div>
        <div class="mb-2" *ngIf="User.email">
          <b>email</b>
          {{ User.email}}
        </div>
        <div class="mb-2" *ngIf="User.timeout">
          <b>timeout</b>
          {{ User.timeout}}
        </div>
        <div class="mb-2" *ngIf="User.expireonsessionend">
          <b>expireonsessionend</b>
          {{ User.expireonsessionend}}
        </div>
        <div class="mb-2 text-break" *ngIf="User.permissions">
          <b>permissions</b>
          {{ User.permissions}}
        </div>
        <div class="mb-2" *ngIf="User.role">
          <b>role</b>
          {{ User.role}}
        </div>
        <div class="mb-2" *ngIf="User.iat">
          <b>Autheticated on</b>
          {{  getFormatedDateFromUnixTime(User.iat)}}
        </div>
        <div class="mb-2" *ngIf="User.nbf">
          <b>Refreshed on</b>
          {{  getFormatedDateFromUnixTime(User.nbf)}}
        </div>
        <div class="mb-2" *ngIf="User.exp">
          <b>Expires on</b>
          {{  getFormatedDateFromUnixTime(User.exp)}}
        </div>
      </div>
      <div id="SessionData" class="tab-pane fade" role="tabpanel" aria-labelledby="SessionData-tab" tabindex="0" *ngIf="Session ">
        <pre>{{ Session | prettyJson}}</pre>
      </div>
      <div id="QueryStringData" class="tab-pane fade" role="tabpanel" aria-labelledby="QueryStringData-tab" tabindex="0" *ngIf="QueryString ">
        <pre>{{ QueryString | prettyJson}}</pre>
      </div>
      <div id="RequestHeaders" class="tab-pane fade " role="tabpanel" aria-labelledby="RequestHeaders-tab" tabindex="0" *ngIf="RequestHeaders ">
        <pre>{{ RequestHeaders | prettyJson}}</pre>
      </div>
      <div id="Cookies" class="tab-pane fade " role="tabpanel" aria-labelledby="Cookies-tab" tabindex="0" *ngIf="Cookies ">
        <pre>{{ Cookies | prettyJson}}</pre>
      </div>
      <div id="ServerVariables" class="tab-pane fade " role="tabpanel" aria-labelledby="ServerVariables-tab" tabindex="0" *ngIf="ServerVariables ">
        <pre>{{ ServerVariables | prettyJson}}</pre>
      </div>
      <div id="ErrorData" class="tab-pane fade " role="tabpanel" aria-labelledby="ErrorData-tab" tabindex="0" *ngIf="FullJson ">
        <pre>{{ FullJson | prettyJson}}</pre>
      </div>
      <div id="Details" class="tab-pane fade show active " role="tabpanel" aria-labelledby="Details-tab" tabindex="0">
        <pre>{{ currentItem?.Detail }}</pre>
      </div>
    </div>
  </div>


  <div class="main-page-content-block-secondary mt-3 " *ngIf="!FullJson && currentItem?.FullJson ">
    <pre>{{ currentItem?.FullJson  | prettyJson}}</pre>
  </div>
</div>





<p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubIssue">Issue</label><br />
      <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
        <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
          {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubComment">Comment</label><br />
      <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>





<p-dialog header="Link Support Ticket" [modal]="true" [(visible)]="ticketVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="ticket">Ticket</label><br />
      <select id="ticket" [(ngModel)]="ticket" [class.div-loading]="loadingTicket" class="form-control">
        <option *ngFor="let ticket of tickets" [ngValue]="ticket">
          {{ticket.Client}} - {{ticket.ID}} -  {{ticket.Subject}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnTicketConfirm" [class.button-loading]="loading" (click)="linkTicket()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnTicketCancel" [class.button-loading]="loading" (click)="ticketVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>
